<template lang="pug">
    v-dialog( persistent max-width="1250px" v-model="open" )
        v-toolbar( color="primary" dark sticky flat )
            v-toolbar-title Detalle de centro de costo
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        crud-form(
            :fields="fields"
            ref="refCFShowCostCenterDetails"
            :editable="$can('EDIT_COST_CENTER')"
            :readOnly="!$can('EDIT_COST_CENTER')"
            @submitForm="submitUpdateCostCenter"
            submitText="Guardar"
            )
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import FieldsShowDetails from './FieldsShowCostCenterDetails'
import { updateCostCenter } from '@/services/api/costCenter'
//-
export default {
    name: 'dialog-show-cost-center',
    props: {
        costCenterObj: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            open: false,
            fields: FieldsShowDetails,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitUpdateCostCenter: function() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Guardar')
            let payload = this.fillSnack(
                'warning',
                '¿Desea guardar y actualizar los cambios?',
                ''
            )
            this.initSnackbar(payload)
        },
        // -- Data fetching
        fillFields: function(data) {
            this.fields[0].value = data.name
            this.fields = [...this.fields]
        },
        // -- Data handling and transformations
        // -- Validations and Error handling
        toggleOpen: function() {
            this.open = !this.open
            this.$refs.refCFShowCostCenterDetails.editSwitch = false
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        open(val) {
            if (val == true) {
                this.fillFields(this.costCenterObj)
            }
        },
        async responseConfirm(val) {
            //-
            if (val === 'Guardar') {
                this.resetSnackbarState()
                let obj = {}
                obj.name = this.$refs.refCFShowCostCenterDetails.vmodels.name
                let response = await updateCostCenter(
                    this.costCenterObj.id,
                    obj
                )
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Centro de costo actualizado',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$emit('success')
                    this.toggleOpen()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>